import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { Datalayer } from '@miro-site/analytics';

function sendAccountPickerShownEvent(_x) {
  return _sendAccountPickerShownEvent.apply(this, arguments);
}

function _sendAccountPickerShownEvent() {
  _sendAccountPickerShownEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getAnalytics) {
    var analytics;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getAnalytics();

          case 3:
            analytics = _context.sent;
            _context.next = 6;
            return analytics.sendEvent(new Datalayer('accountPickerShown', {
              openedFrom: 'templates'
            }));

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _sendAccountPickerShownEvent.apply(this, arguments);
}

function sendAccountSelectedInAccountPickerEvent(_x2, _x3) {
  return _sendAccountSelectedInAccountPickerEvent.apply(this, arguments);
}

function _sendAccountSelectedInAccountPickerEvent() {
  _sendAccountSelectedInAccountPickerEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref, callback) {
    var accountId, accountsListIndex, workspaceKey, getAnalytics, analytics;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accountId = _ref.accountId, accountsListIndex = _ref.accountsListIndex, workspaceKey = _ref.workspaceKey, getAnalytics = _ref.getAnalytics;
            _context2.prev = 1;
            _context2.next = 4;
            return getAnalytics();

          case 4:
            analytics = _context2.sent;
            _context2.next = 7;
            return analytics.sendEvent(new Datalayer('accountPickerAccountSelected', {
              accountsListIndex: accountsListIndex,
              accountId: accountId,
              workspaceKey: workspaceKey
            }));

          case 7:
            if (callback) {
              callback();
            }

            _context2.next = 13;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            console.error(_context2.t0);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));
  return _sendAccountSelectedInAccountPickerEvent.apply(this, arguments);
}

export function useAccountPicker(_ref2) {
  var onAccountLoaded = _ref2.onAccountLoaded,
      onAccountSubmited = _ref2.onAccountSubmited,
      onAccountCancel = _ref2.onAccountCancel,
      onAccountError = _ref2.onAccountError,
      getAnalytics = _ref2.getAnalytics;

  var _useState = useState(false),
      isAccountPickerVisible = _useState[0],
      setAccountPickerVisible = _useState[1];

  useEffect(function () {
    if (isAccountPickerVisible) {
      sendAccountPickerShownEvent(getAnalytics);
    }
  }, [isAccountPickerVisible]);

  var onAccountPickerLoaded = function onAccountPickerLoaded(accountsIds, workspaceKey) {
    if (!Array.isArray(accountsIds)) {
      return;
    }

    var accountsLength = accountsIds.length;

    switch (accountsLength) {
      //in application user will use account creation flow
      case 0:
        onAccountLoaded(undefined, workspaceKey);
        break;
      //copy board to single account. no need to select

      case 1:
        onAccountLoaded(accountsIds[0], workspaceKey);
        break;
      //user will select account to copy board

      default:
        setAccountPickerVisible(true);
        break;
    }
  };

  var onAccountPickerSubmit = function onAccountPickerSubmit(accountId, accountsListIndex, workspaceKey) {
    sendAccountSelectedInAccountPickerEvent({
      accountId: accountId,
      accountsListIndex: accountsListIndex,
      workspaceKey: workspaceKey,
      getAnalytics: getAnalytics
    }, function () {
      onAccountSubmited(accountId, workspaceKey);
    });
  };

  var onAccountPickerCancel = function onAccountPickerCancel() {
    onAccountCancel();
    setAccountPickerVisible(false);
  };

  return [isAccountPickerVisible, onAccountPickerLoaded, onAccountPickerSubmit, onAccountPickerCancel, onAccountError];
}